/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { Link } from "react-router-dom";
import { ReactComponent as SimpliCityLogo } from "cms/assets/images/SimpliCity-logo.svg";

const Header = () => {

    const contactLink = "mailto:info@simplicitycms.ca?subject=Inquiry%20re%3A%20SimpliCity%20CMS";
    // const demoLink = "mailto:info@simplicitycms.ca?subject=Demo%20re%3A%20SimpliCity%20CMS";
    const demoWatchLink = "https://simplicity.ewebinar.com/webinar/simplicity-walkthrough-building-a-unified-digital-foundation-to-solve-municipal-fragmentation-23743?source=card&referrer=https%3A%2F%2Fmain-admin.simplicitycms.ca%2F";

    return (
        <div className="header">
            <div className="header-content">
                <Link to="/" className="simplicity-logo">
                    <SimpliCityLogo alt="simplicity-logo" />
                </Link>
                <div className="header-buttons">
                    <a href={contactLink} className="contact-button">Contact</a>
                    {/*<a href={demoLink} className="demo-button">Book a Demo</a>*/}
                    <a
                        href={demoWatchLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="demo-button"
                    >
                        Watch a demo now
                    </a>
                </div>
            </div>
        </div>
    );
};

export { Header };
